import axios from "axios";
import { baseURL } from "./Constant";

const loginApi = async (email, password) => {
  try {
    return axios.post(`${baseURL}/auth/local`, { email: email, password });
  } catch (error) {
    throw error;
  }
};

const logoutApi = async (currentUser) => {
  try {
    return axios.post(`${baseURL}/auth/logout`, {},
      {
        headers: {
          Authorization: `Bearer ${currentUser?.jwt}`,
        },
      }
    );
  } catch (error) {
    throw error;
  }
};

const forgotPasswordApi = async (email) => {
  try {
    return axios.post(`${baseURL}/auth/forgot-password`, { email });
  } catch (error) {
    throw error;
  }
};

const resetPasswordApi = async ({ newPassword, confirmPassword, code }) => {
  try {
    return axios.post(`${baseURL}/auth/reset-password`, {
      password: newPassword,
      passwordConfirmation: confirmPassword,
      code,
    });
  } catch (error) {
    throw error;
  }
};

const resetPasswordCodeCheck = async (code) => {
  try {
    return axios.get(`${baseURL}/auth/code-link-valid`, {
      params: {
        code: code
      }
    });
  } catch (error) {
    throw error;
  }
};

const jwtValidateApi = async (token) => {
  try {
    const response = await axios.post(
      `${baseURL}/jwt/validate`,
      {
        token: token, 
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    console.error("jwtValidateApi - Error:", error);
    throw error;
  }
};

export { loginApi, logoutApi, forgotPasswordApi, resetPasswordApi, resetPasswordCodeCheck, jwtValidateApi };
